import { render, staticRenderFns } from "./AdminPanelView.vue?vue&type=template&id=0cdd32a0&scoped=true&"
import script from "./AdminPanelView.vue?vue&type=script&lang=js&"
export * from "./AdminPanelView.vue?vue&type=script&lang=js&"
import style0 from "./AdminPanelView.vue?vue&type=style&index=0&id=0cdd32a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdd32a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VIcon,VRow})
